import { TableSettings } from '../types/table_settings/TableSettings';
import {
  CreateTableSettingsInput,
  DeleteTableSettingsInput,
  UpdateTableSettingsInput,
} from '../types/table_settings/tableSettings.input';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/table_settings/list';
const CREATE = '/api/table_settings/create';
const UPDATE = '/api/table_settings/update';
const DELETE = '/api/table_settings/delete';

export namespace TableSettingsRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<TableSettings<any>>> => {
    return (await http.post(LIST, payload)).data;
  };

  export const create = async (payload: { data: CreateTableSettingsInput[] }): Promise<TableSettings<any>[]> => {
    return (await http.post(CREATE, payload)).data;
  };

  export const update = async (payload: { data: UpdateTableSettingsInput[] }): Promise<TableSettings<any>[]> => {
    return (await http.post(UPDATE, payload)).data;
  };

  export const remove = async (payload: DeleteTableSettingsInput): Promise<void> => {
    return (await http.post(DELETE, payload)).data;
  };
}
